import SelectEventForDelivery from "../../../Components/Delivery/SelectEvent/SelectEvet";

export default function HomeDelivery() {
    return (
        <>
            <SelectEventForDelivery />
        </>
    )
}